import { useCallback } from 'react';
import { useAclContext } from '../../Acl/Components/AclContextProvider';
import { MZCR_SETTINGS_URL } from '../Utils/mzcrUrls';
import useMzcrAccess from './useMzcrAccess';

/**
 * Link to the workplace settings (MZČR tab) – only for users who may manage the workplace and set
 * MZČR up. `onOpenCertificateSettings` is `undefined` for the others.
 */
export default function useMzcrSettingsLink() {
	const { isAllowed } = useAclContext();
	const { canSetup } = useMzcrAccess();
	const canOpenSettings = canSetup && isAllowed('manager_workplace');

	const openSettings = useCallback(
		() => window.location.assign(MZCR_SETTINGS_URL),
		[],
	);

	return {
		canOpenSettings,
		onOpenCertificateSettings: canOpenSettings ? openSettings : undefined,
	};
}
